module.exports = __webpack_public_path__ + "img/holiday_message.fb49df79.gif";